// src/components/SimpleComponents/SimpleDatePicker.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DatePicker } from 'antd';
import SimpleFormItem from './SimpleFormItem';
import useFormElement from 'hooks/useFormElement';
import { useSimpleFormContext } from './SimpleFormProvider';
import useSubscriptionLocale from 'hooks/useSubscriptionLocale';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleDatePicker = ({
  name,
  subdocumentField,
  format,
  showTime = false,
  className = '',
  disabled,
  picker,
  ...props
}) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { locked, disabledFields } = useSimpleFormContext();

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------
  const elementProps = useFormElement(name, subdocumentField);
  const { elementRef, fullFieldName, flattenFieldName } = elementProps;
  const subscriptionLocale = useSubscriptionLocale();

  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------
  const isDisabled = disabled || locked || disabledFields?.includes(flattenFieldName);
  const effectiveFormat = format ?? subscriptionLocale.dateFormat;

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 5. EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 6. HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <SimpleFormItem {...props} name={fullFieldName} elementProps={elementProps} isDatePicker={true}>
      <DatePicker
        ref={elementRef}
        id={flattenFieldName}
        className={`w-100 no-border-radius ${className}`}
        format={effectiveFormat}
        showTime={showTime}
        disabled={isDisabled}
        picker={picker}
      />
    </SimpleFormItem>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleDatePicker;

// *******************************************************************************
// HELPERS
// *******************************************************************************
